import { ROUTE_PATHS } from '@constants';

const SUBSCRIPTION_ORDERS_FAQ = {
    LINK: '/pricing-and-how-we-charge/',
    HASH: 'do-commissions-differ-for-subscription-orders'
};

export const SUBSCRIPTION_ORDERS_FAQ_PATH = `${ROUTE_PATHS.HELP_CENTER}?link=${SUBSCRIPTION_ORDERS_FAQ.LINK}&hash=${SUBSCRIPTION_ORDERS_FAQ.HASH}`;

export const TOOLTIP_PLACEMENTS = {
    ABOVE_TRIGGER: 'top',
    BELOW_TRIGGER: 'bottom'
};

export const TOOLTIP_SIZES = {
    MIN_WIDTH: 308,
    WIDE_MAX_WIDTH: 408,
    MIN_HEIGHT: 216,
    MAX_HEIGHT: 304,
    BORDER_RADIUS: 4,
    ARROW_OFFSET: 18
};
